"use client"

import { useEffect } from "react"
import { useRouter } from "next/navigation"
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { useErrorReport } from "@/hooks/useErrorReport"

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const router = useRouter()

  useErrorReport({
    error,
    digest: error.digest,
    context: { origem: "app/global-error.tsx" },
  })

  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <html lang="pt-BR">
      <body>
        <div className="container flex items-center justify-center min-h-screen py-12">
          <Card className="w-full max-w-md">
            <CardHeader className="space-y-1">
              <CardTitle className="text-2xl font-bold text-center">
                Erro Crítico
              </CardTitle>
              <CardDescription className="text-center text-muted-foreground">
                Ocorreu um erro inesperado no sistema.
              </CardDescription>
            </CardHeader>
            <CardContent className="flex flex-col items-center gap-4">
              <p className="text-sm text-center text-muted-foreground">
                Por favor, tente recarregar a página ou volte para a página inicial.
              </p>
              {error.digest && (
                <p className="text-xs text-muted-foreground">
                  Error ID: {error.digest}
                </p>
              )}
              <div className="flex gap-2">
                <Button onClick={() => reset()} variant="outline">
                  Tentar novamente
                </Button>
                <Button onClick={() => router.push("/")} variant="default">
                  Página inicial
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </body>
    </html>
  )
}
